declare module '*.mustache' {
    const wrapper: {
        render: (params: Record<string, unknown>) => string;
    };
    export default wrapper;
}
